var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.showMenu & _vm.showMenu != 'undefined')?_c('div',[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner box-shadow"},[_c('div',{attrs:{"id":"overlay"}}),_c('div',{staticClass:"box"},[_c('div',{staticClass:"content"},[_vm._v("Creative Services For Boost Your Learning Growth "),_c('br')])])])
}]

export { render, staticRenderFns }